<template>
  <div>
  <v-dialog :value="filterForm.openQuickView" :maxWidth="innerWidth > 1440 ? '80%' : '99%'" :contentClass="innerWidth > 1440 ? '' :'custom-width-ml'" persistent>
    <v-card class="text-center quick-view">
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Thông tin cơ bản
        <v-divider style="border-color: #d2d2d2" class="mt-3 mb-3"></v-divider>
        <v-spacer />
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-9 pt-0">
        <v-row>
          <v-col cols="12" md="4" class="border-right" style="text-align: left;">
            <v-row style="margin-top: -15px">
              <v-col cols="12" md="12" class="pa-0" >
                <div class="d-flex justify-space-between mb-3 mt-2">
                  <span class="font-weight-bold">
                    {{codeAndMobile}}
                    <span v-if="dataContact.zuid">
                      <img src = "../../../../public/img/zalo.svg" alt="Zalo" class="ml-1" style="width: 16px;height: 16px;vertical-align: middle;" />
                    </span>
                    <v-tooltip v-if="checkContactSources(dataContact.contactSources)" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          size="16"
                          width="20"
                          height="20"
                          class="mr-1"
                          icon
                          small
                          color="info"
                          v-on="on"
                        >
                          <v-icon size="16">mdi-facebook-messenger</v-icon>
                        </v-btn>
                      </template>
                      <span>Nhắn tin</span>
                    </v-tooltip>
                  </span>
                  <!-- <v-btn v-if="checkConditionT4NT5(_.get(this.dataContact, 'contactStatus.type', '')) && !checkIncludesT4NT5(_.get(this.dataContact, 'contactStatus.type', ''))" @click="createOrder(dataContact.id)" small color="primary">Tạo đơn hàng </v-btn> -->
                  <!-- <v-btn @click="createOrder(dataContact.id)" small color="primary">Tạo đơn hàng </v-btn> -->
                 <span>
                  <v-btn
                    @click="requiredSupport(dataContact.code)"
                    small color="#FFC700">  <v-icon size="16">mdi-headphones</v-icon> <span class="ml-1">Yêu cầu hỗ trợ</span></v-btn>
                   <v-btn
                   v-if="checkAuthorization('order_create') && checkNotIncludesM(dataContact.contactStatus.type)"
                   @click="createOrder(dataContact.id)"
                   small color="primary">Tạo đơn hàng</v-btn>
                   <!-- <v-btn
                   v-if="checkAuthorization('order_create') && checkNotIncludesM(dataContact.contactStatus.type)"
                   @click="createOrderNew(dataContact.id)"
                   small color="primary">Tạo đơn hàng</v-btn> -->
                  </span>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <span @click="clickContactDetail(dataContact.id)" style="cursor: pointer;">
                  <v-icon color="primary">mdi-account</v-icon>
                  <span style="margin-left: 5px;">{{_.get(dataContact, 'contactFullName', '')}}</span>
                </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0 d-flex">
                <v-tooltip bottom v-if="!_.isEmpty(dataZalo) && checkAuthorization('call-zalo_read')
                && ( (dataZalo.followed_ZL_BGVVH && dataContact.typeId == 2) ||  (dataZalo.followed_ZL_CVHT && dataContact.typeId != 2))
                && dataContact.contactType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="clickExecuteCall(dataContact, dataContact.mobile, false, dataContact.typeId == 2 ? 'ZL_BGVVH' : 'ZL_CVHT')" class="mr-1" v-bind="attrs"
                        :color="dataZalo.ZL_BGVVH && dataContact.typeId == 2? '#339DFF' : (dataZalo.ZL_CVHT && dataContact.typeId != 2) ? '#339DFF' : '#A4A4A4'" v-on="on">mdi-microphone</v-icon>
                    </template>
                    <span>Gọi qua Zalo : {{dataContact.typeId == 2 ? ' Ban giáo vụ VH' : 'Cố vấn học tập'}}</span>
                </v-tooltip>
                <span v-if="!_.isEmpty(dataZalo) && checkAuthorization('call-zalo_read') && dataContact.contactType == 'main'" style="cursor: pointer;">Gọi cho khách hàng</span>

               <div>
                <v-menu offset-y v-if="dataContact.contactType == 'main' && !isNormalCall && listCallOptions && listCallOptions.length > 0">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            size="18"
                            width="25"
                            height="25"
                            class="mr-1"
                            icon
                            small
                            color="#C08B00"
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="20">mdi-swap-horizontal-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(option, index) in listCallOptions" :key="index"
                        :class="selectedCallOptions.type === option.type === 'auto' ?  'main-mobile' : selectedCallOptions.brandnameCode === option.brandnameCode ? 'main-mobile' : 'sub-mobile'"
                    >
                      <v-menu offset-x v-if="dataContact.contactType == 'main'">
                        <template v-slot:activator="{ on: on, attrs }">
                            <v-list-item-title
                                v-bind="attrs"
                                v-on="on"
                                @click="SET_SELECTED_CALL_OPTION(option)">Gọi {{ option.type === 'auto' ? 'Auto' : option.brandnameCode}}
                            </v-list-item-title>
                        </template>
                        <v-list>
                          <v-list-item
                              @click="clickExecuteCall(dataContact, dataContact.mobile)"
                        class="main-mobile"
                    >
                            <v-list-item-title>{{dataContact.mobile}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                              v-for="(phone, index) in dataContact.phoneRelated"
                              :key="index"
                              @click="clickExecuteCall(dataContact, phone)"
                        class="sub-mobile"
                    >
                            <v-list-item-title>{{phone}}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item>
                  </v-list>
                </v-menu>
               </div>
               <div>
                <v-menu offset-y v-if="dataContact.contactType == 'main'" >
                  <template v-slot:activator="{ on: on, attrs }">
                    <span v-if="!checkAuthorization('call-zalo_read')" style="cursor: pointer;">Gọi cho khách hàng</span>
                    <v-btn
                      class="mr-1"
                      icon
                      small
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>mdi-phone</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="clickExecuteCall(dataContact, dataContact.mobile, true)"
                      class="main-mobile"
                    >
                      <v-list-item-title>{{dataContact.mobile}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(phone, index) in dataContact.phoneRelated"
                      :key="index"
                      @click="clickExecuteCall(dataContact, phone, true)"
                      class="sub-mobile"
                    >
                      <v-list-item-title>{{phone}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
               </div>
                <div>
                  <!-- <v-tooltip bottom v-if="!_.isEmpty(dataZalo) && checkAuthorization('call-zalo_read') && dataZalo.followed_ZL_CVHT && dataContact.contactType == 'main' ">
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="clickExecuteCall(dataContact, dataContact.mobile, false, 'ZL_CVHT')" class="mr-1" v-bind="attrs"  :color="dataZalo.ZL_CVHT ? '#339DFF' : '#A4A4A4'" size="18" v-on="on">mdi-microphone</v-icon>
                  </template>
                  <span>Gọi qua Zalo :  Cố vấn học tập</span>
                </v-tooltip> -->

                <v-tooltip bottom v-if="!_.isEmpty(dataZalo) && checkAuthorization('call-zalo_read')
                && ( (dataZalo.followed_ZL_BGVVH && dataContact.typeId != 2) ||  (dataZalo.followed_ZL_CVHT && dataContact.typeId == 2))
                && dataContact.contactType == 'main'">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="clickExecuteCall(dataContact, dataContact.mobile, false, dataContact.typeId != 2 ? 'ZL_BGVVH' : 'ZL_CVHT')" class="mr-1" v-bind="attrs"
                        :color="dataZalo.ZL_BGVVH && dataContact.typeId != 2? '#339DFF' : (dataZalo.ZL_CVHT && dataContact.typeId == 2) ? '#339DFF' : '#A4A4A4'" v-on="on">mdi-microphone</v-icon>
                    </template>
                    <span>Gọi qua Zalo : {{dataContact.typeId != 2 ? ' Ban giáo vụ VH' : 'Cố vấn học tập'}}</span>
                </v-tooltip>
                </div>
                <span  style="cursor: pointer;" v-if="dataContact.contactType != 'main'">
                  <v-btn v-if="!checkAuthorization('call-zalo_read')" @click="clickExecuteCall(dataContact, dataContact.mobile, true)" style="margin-left: -5px"  icon small color="success">
                      <v-icon>mdi-phone</v-icon>
                  </v-btn>
                  <v-tooltip bottom v-if="!_.isEmpty(dataZalo) && checkAuthorization('call-zalo_read') &&  ( (dataZalo.followed_ZL_BGVVH && dataContact.typeId == 2) ||  (dataZalo.followed_ZL_CVHT && dataContact.typeId != 2))">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon @click="clickExecuteCall(dataContact, dataContact.mobile, false, dataContact.typeId == 2 ? 'ZL_BGVVH' : 'ZL_CVHT')" class="mr-1" v-bind="attrs"
                        :color="dataZalo.ZL_BGVVH && dataContact.typeId == 2? '#339DFF' : (dataZalo.ZL_CVHT && dataContact.typeId != 2) ? '#339DFF' : '#A4A4A4'" v-on="on">mdi-microphone</v-icon>
                    </template>
                    <span>Gọi qua Zalo : {{dataContact.typeId == 2 ? ' Ban giáo vụ VH' : 'Cố vấn học tập'}}</span>
                  </v-tooltip>


                  <span>Gọi cho khách hàng</span>
                  <v-menu offset-y v-if="!isNormalCall && listCallOptions && listCallOptions.length > 0">
                  <template v-slot:activator="{ on: menu, attrs }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            size="18"
                            width="25"
                            height="25"
                            class="mr-1"
                            icon
                            small
                            color="#C08B00"
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                        >
                          <v-icon size="20">mdi-swap-horizontal-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Gọi cho khách hàng</span>
                    </v-tooltip>
                  </template>
                  <v-list>
                    <v-list-item
                        v-for="(option, index) in listCallOptions" :key="index"
                        @click="setSelectedCallOption(dataContact, dataContact.mobile, option)"
                        :class="selectedCallOptions.type === option.type === 'auto' ?  'main-mobile' : selectedCallOptions.brandnameCode === option.brandnameCode ? 'main-mobile' : 'sub-mobile'"
                    >
                      <v-list-item-title>Gọi {{ option.type === 'auto' ? 'Auto' : option.brandnameCode}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-btn v-if="checkAuthorization('call-zalo_read')" @click="clickExecuteCall(dataContact, dataContact.mobile, true)" icon small color="success" dark>
                    <v-icon>mdi-phone</v-icon>

                </v-btn>
                <v-tooltip bottom v-if="!_.isEmpty(dataZalo) && checkAuthorization('call-zalo_read') && ( (dataZalo.followed_ZL_BGVVH && dataContact.typeId != 2) ||  (dataZalo.followed_ZL_CVHT && dataContact.typeId == 2)) ">
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="clickExecuteCall(dataContact, dataContact.mobile, false, dataContact.typeId != 2 ? 'ZL_BGVVH' : 'ZL_CVHT')" v-bind="attrs" v-on="on" size="18"
                      :color="dataZalo.ZL_BGVVH && dataContact.typeId != 2? '#339DFF' : (dataZalo.ZL_CVHT && dataContact.typeId == 2) ? '#339DFF' : '#A4A4A4'">mdi-microphone</v-icon>

                  </template>
                  <span>Gọi qua Zalo :  {{dataContact.typeId != 2 ? ' Ban giáo vụ VH' : 'Cố vấn học tập'}}</span>
                </v-tooltip>
                </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <span @click="clickHistoryCall(dataContact.mobile)" style="cursor: pointer;">
                  <v-btn style="margin-left: -5px"  icon small color="grey" dark>
                      <v-icon>mdi-file-music</v-icon>
                    </v-btn>
                  <span>Lịch sử cuộc gọi</span>
                </span>
              </v-col>
              <v-col cols="12" md="6" class="pa-0">
                <span @click="clickNewAppointment(dataContact)" v-if="checkConditionT4NT5(_.get(this.dataContact, 'contactStatus.type', ''))" style="cursor: pointer;">
                    <v-btn style="margin-left: -5px"  icon small color="warning">
                      <v-icon>mdi-timer</v-icon>
                    </v-btn>
                  <span>Tạo lịch hẹn</span>
                </span>
              </v-col>
              <v-col cols="12" md="12" class="pa-0" v-if="dataContact.appointment">
                <span style="cursor: pointer;">
                  <v-btn style="margin-left: -5px"  icon small color="secondary" dark>
                      <v-icon>mdi-bell</v-icon>
                  </v-btn>
                  <span class="mr-2 appointment-time-wrapper">
                    <span @click="editAppointment(dataContact)" style="cursor: pointer">{{checkAppointmentTime(dataContact.appointment.date)}}</span>&nbsp;
                  </span>
                  <!-- <v-menu offset-y v-if="statusCallCenter() && dataContact.contactType == 'main'">
                    <template v-slot:activator="{ on: menu, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            dark
                            small
                            icon
                            v-bind="attrs"
                            v-on="{...tooltip, ...menu}"
                          >
                            <v-icon color="green" size="16">mdi-phone</v-icon>
                          </v-btn>
                        </template>
                        <span>Thực hiện lịch hẹn</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                      <v-list-item
                        @click="showAppoimentAction(dataContact, dataContact.mobile)"
                        class="main-mobile"
                      >
                        <v-list-item-title>{{dataContact.mobile}}</v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        v-for="(phone, index) in dataContact.phoneRelated"
                        :key="index"
                        @click="showAppoimentAction(dataContact, phone)"
                        class="sub-mobile"
                      >
                        <v-list-item-title>{{phone}}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-tooltip v-else-if="statusCallCenter()" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        dark
                        small
                        icon
                        v-on="on"
                        @click="showAppoimentAction(dataContact, dataContact.mobile)"
                      >
                        <v-icon color="green" size="16">mdi-phone</v-icon>
                      </v-btn>
                    </template>
                    <span>Thực hiện lịch hẹn</span>
                  </v-tooltip> -->
                </span>
              </v-col>
<!--              <v-col cols="12" md="6" class="pa-0">-->
<!--                <v-icon color="blue" style="margin-right: 4px;">mdi-filter</v-icon>-->
<!--                <span>Mối quan hệ: {{dataContact.contactStatus.name}}</span>-->
<!--              </v-col>-->

              <v-col
                  v-if="(checkAuthorization('order_create') || checkAuthorization('admin-search_read'))"
                  cols="12" md="6" class="pa-0">
                <span
                    @click="viewInteractions"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px"  icon small color="blue">
                      <v-icon>mdi-book-open-page-variant</v-icon>
                    </v-btn>
                  <span>Đo lường tương tác</span>
                </span>
              </v-col>

              <v-col
                  v-if="(checkAuthorization('order_create') || checkAuthorization('admin-search_read'))"
                  cols="12" md="6" class="pa-0">
                <span
                    @click="viewActiveCodes(dataContact)"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px"  icon small color="blue">
                      <v-icon>mdi-codepen</v-icon>
                    </v-btn>
                  <span>Mã kích hoạt</span>
                </span>
              </v-col>

              <v-col cols="12" md="6" class="pa-0" v-if="dataContact.lastExamAt">
                <span
                    @click="viewLogDGNL(dataContact)"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px" icon small color="red">
                      <v-icon>mdi-note-text</v-icon>
                    </v-btn>
                  <span>Thi ĐGNL</span>
                </span>
              </v-col>

              <v-col
                  cols="12" md="6" class="pa-0">
                <span
                    @click="showModalZaloZns"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px"  icon small color="blue">
                      <v-icon>mdi-message-processing</v-icon>
                    </v-btn>
                  <span>Gửi tin tự động</span>
                </span>
              </v-col>

              <v-col
                  v-if="typeSystem"
                  cols="12" md="6" class="pa-0">
                      <span
                          @click="handlePopupSchool(dataContact.id)"
                          style="cursor: pointer;">
                          <v-btn style="margin-left: -5px"  icon small color="red">
                             <v-icon>mdi-map-marker-plus</v-icon>
                          </v-btn>
                        <span>Tìm trường</span>
                      </span>
              </v-col>

              <v-col cols="12" md="6" class="pa-0" v-if="isHaveServey">
                <span
                    @click="handlePopupServey(dataContact.id)"
                    style="cursor: pointer;">
                    <v-btn style="margin-left: -5px"  icon small color="red">
                       <v-icon>mdi-chart-pie-outline </v-icon>
                    </v-btn>
                  <span>Kết quả khảo sát</span>
                </span>
              </v-col>
              <v-col cols="12" md="12" class="pa-0 mt-3 pr-3">
                <v-autocomplete
                  :readonly="!checkAuthorization('contact_change_status_read') || !checkConditionT4NT5(_.get(this.dataContact, 'contactStatus.type', ''))"
                  v-model="statusId"
                  :items="contactStatusList"
                  item-text="otherName"
                  item-value="id"
                  label="Trạng thái"
                  @change="changeSelectStatus"
                />
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                        :value="formatDate(dataContact.assignedAt)"
                        label="Ngày phân bổ contact"
                        readonly
                        disabled
                    />
                  </v-col>
                  <v-col cols="12" md="6" class="select-assign-user">
                    <common-select-user
                        :readonly="!checkAuthorization('contact_change_user_read')"
                        v-model="userId"
                        :items="getSelectUser"
                        label="Người phụ trách"
                        color="primary"
                        item-text="fullName"
                        item-value="id"
                        :changeUser="changeSelectUser"
                    />
                  </v-col>
                </v-row>
<!--                <v-row>-->
<!--                  <v-col cols="12" md="6">-->
<!--                    <v-text-field-->
<!--                        class="pa-0"-->
<!--                        :value="formatDate(dataContact.importUpdatedAt)"-->
<!--                        label="Ngày đăng ký"-->
<!--                        readonly-->
<!--                        disabled-->
<!--                    />-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" md="6">-->
<!--                    <v-text-field-->
<!--                        v-if="!isStaff()"-->
<!--                        class="pa-0"-->
<!--                        :value="dataContact.contactSources"-->
<!--                        label="Nguồn contact"-->
<!--                        readonly-->
<!--                        disabled-->
<!--                    />-->
<!--                  </v-col>-->
<!--                </v-row>-->
                <v-row>
<!--                  <v-col align="center" justify="space-around">-->
<!--                    <v-btn-->
<!--                        v-if="checkAuthorization('order_create')"-->
<!--                        @click="createOrder(dataContact.id)"-->
<!--                        small-->
<!--                        color="primary"-->
<!--                    >Chiến dịch marketing</v-btn-->
<!--                    >-->
<!--                  </v-col>-->
<!--                  <v-col cols="12" sm="12" align="center" justify="space-around">-->
<!--                    <v-btn-->
<!--                        v-if="(checkAuthorization('order_create') || checkAuthorization('admin-search_read'))"-->
<!--                        @click="viewInteractions"-->
<!--                        small-->
<!--                        color="primary"-->
<!--                    >Đo lường tương tác ({{dataInteraction.cumulative_point ? dataInteraction.cumulative_point : 0}})</v-btn-->
<!--                    >-->
<!--                  </v-col>-->
                </v-row>
              </v-col>
              <v-col cols="12" md="12" class="pa-0">
                <b style="font-size:14px;font-weight:700;line-height:20px">TAG ĐÍNH KÈM</b>
                <div class="pa-0">
                  <div class="mt-2 mr-3 pa-3 class-list">
                    <v-chip
                        class="ma-2"
                        outlined
                        style="height: 28px"
                        v-for="(tag, index) in tagByContact"
                        :color="tag.tagColor"
                        :key="index"
                    >
                      <span @click="openLink(tag)" style="cursor: pointer;">
                        {{tag.tagName}}
                        <v-icon  v-ripple right style="font-size: 14px;">
                          {{tag.tagIcon}}
                      </v-icon>
                    </span>
                    </v-chip>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="12" class="pa-0">
                <b style="font-size:14px;font-weight:700;line-height:20px">LỚP HỌC CỦA HỌC SINH</b>
                <div class="pa-0">
                  <button
                    v-for="(i, key) in dataContact.childCustomer"
                    :key="key"
                    style="margin-right: 10px"
                    class="customer-learning"
                    :id="`customer-learning-${key}`"
                    @click="getClassListOfChild(key, i.vhUserId)"
                  >
                    {{ i.fullName }}
                  </button>
                </div>
                <div class="mt-2 mr-3 pa-3 class-list">
                  <div v-if="classListTutor.length" class="mb-4">
                    <span class="label-class-type" style="background: #FF5C00;">Gia sư</span>
                    <div
                      class="class-item mt-2"
                      v-for="(item,key) in classListTutor"
                      :key="key"
                    >
                      <span style="display: -webkit-box !important">
                        <v-icon style="margin-right:5px">mdi-book-open-blank-variant</v-icon>
                        <b style="font-weight:700">{{item.name}}</b>
                      </span>
                      <span>
                        <v-icon style="margin-right:5px">mdi-account</v-icon>
                        <span>
                          <span :style="'font-weight:600;color:'+item.status_color">{{item.status_name}}</span>
                          <span v-if="item.status_name === 'Lớp nháp'">
                            <v-badge color="white">
                              <template #badge>
                                <v-tooltip top color="white" content-class="join-date-tooltip">
                                    <template v-slot:activator="{on , attrs}">
                                      <v-icon style="margin-left: 6px" v-bind="attrs" v-on="on" size="18" color="black">mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <div>
                                      <div style="font-size: 12px">Lớp khai giảng : {{formatDateCus(item.class_start_time, 'DD/MM/YYYY')}}</div>
                                    </div>
                                </v-tooltip>
                              </template>
                              {{' | Ngày vào lớp: ' }}
                              <span style="margin-left: 6px">-</span>
                            </v-badge>
                          </span>
                          <span v-if="isReserve(item)">
                            {{ `Ngày đi học lại: ${item.learn_again_time}` }}
                          </span>
                          <span v-if="item.join_date && item.join_date !== ''">
                            <v-badge color="white">
                              <template #badge>
                                <v-tooltip top color="white" content-class="join-date-tooltip">
                                    <template v-slot:activator="{on , attrs}">
                                      <v-icon v-bind="attrs" v-on="on" size="18" color="black">mdi-information-outline
                                      </v-icon>
                                    </template>
                                    <div>
                                      <div style="font-size: 12px">Lớp khai giảng : {{formatDateCus(item.class_start_time, 'DD/MM/YYYY')}}</div>
                                      <div style="color: blue; font-size: 12px; font-weight: bold">-
                                        <span v-if="isSameDate(item.class_start_time, item.join_date)">Học từ đầu chương trình</span>
                                        <span v-else>Học từ giữa chương trình</span>
                                      </div>
                                    </div>
                                </v-tooltip>
                              </template>
                              {{ ` | Ngày vào lớp: ${formatDateCus(item.join_date, 'DD/MM/YYYY')}` }}
                            </v-badge>
                          </span>
                        </span>
                      </span><br>
                      <div v-if="item.class_schedule && item.class_schedule.length" style="display: flex">
                        <div>
                          <v-icon style="margin-right:5px;">mdi-calendar-check</v-icon>
                        </div>
                        <div>
                          <div
                            v-for="(i,k) in item.class_schedule"
                            :key="k"
                            style="line-height: 1.5em;"
                          >
                            <div v-if="i.schedule && i.schedule.length">
                              <span v-for="(schedule, key_s) in i.schedule" :key="key_s" style="margin-right:5px">
                                {{schedule.time}} | ({{schedule.day}})
                              </span>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div>
                        <span style="display: -webkit-box !important">
                          <v-icon style="margin-right:5px">mdi-content-save</v-icon>
                          <b>Đã học: {{item.number_lessons_passed ? item.number_lessons_passed : 0}}/{{item.number_lessons ? item.number_lessons : 0}} (buổi)</b>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div v-if="classListDuo.length">
                    <span class="label-class-type" style="background: #0055FB;">Duo</span>
                    <div
                      class="class-item mt-2"
                      v-for="(item,key) in classListDuo"
                      :key="key"
                    >
                      <span style="display: -webkit-box !important">
                        <v-icon style="margin-right:5px">mdi-book-open-blank-variant</v-icon>
                        <b style="font-weight:700">{{item.name}}</b>
                      </span>
                      <span>
                        <v-icon style="margin-right:5px">mdi-account</v-icon>
                        <span>
                          <span :style="'font-weight:600;color:'+item.status_color">{{item.status_name}}</span>
                          <span v-if="item.live_class_name" style="margin-left:7px">| {{ item.live_class_name }}</span>
                        </span>
                      </span><br>
                      <div v-if="item.class_schedule && item.class_schedule.length" style="display: flex">
                        <div>
                          <v-icon style="margin-right:5px;">mdi-calendar-check</v-icon>
                        </div>
                        <div
                          v-for="(i,k) in item.class_schedule"
                          :key="k"
                          style="line-height: 1.5em;"
                        >
                          <span style="margin-right:5px">
                            {{i.time}} | ({{i.day}})
                          </span>
                        </div>
                      </div>
<!--                      <div>-->
<!--                        <span style="display: -webkit-box !important">-->
<!--                          <v-icon style="margin-right:5px">mdi-content-save</v-icon>-->
<!--                          <b>Đã học: {{item.number_lessons_passed ? item.number_lessons_passed : 0}}/{{item.number_lessons ? item.number_lessons : 0}} (buổi)</b>-->
<!--                        </span>-->
<!--                      </div>-->
                    </div>
                  </div>
                  <div v-if="!classListTutor.length && !classListDuo.length">Không có danh sách học sinh</div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="8">
            <validation-observer v-slot="{ handleSubmit }">
              <v-row style="margin-top: -30px">
                <v-col cols="12" md="12" style="text-align: right;" v-if="showNote && tab != 1">
                  <validation-provider
                    v-slot="{ errors }"
                    name="Thông tin ghi chú"
                    :rules="{required: reloadCreateNote, max:255}"
                  >
                    <v-textarea
                      label="Nhập ghi chú"
                      rows="3"
                      v-model="note"
                      :error-messages="errors"
                      @keydown.enter.exact.prevent="handleSubmit(clickCreateHistoryContact)"
                    />
                  </validation-provider>
                  <v-btn
                    class="d-flex"
                    small
                    @click.prevent="handleSubmit(clickCreateHistoryContact)"
                    color="primary"
                    style="float: left"
                  >Tạo</v-btn>
                  <v-btn
                    v-show="isSupport"
                    small
                    @click="returnToBackStatus()"
                    color="primary"
                    style="float: right"
                  >Đã hỗ trợ CSKH</v-btn>
                </v-col>
                <v-tabs
                    v-model="tab"
                    grow>
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab
                    v-for="(item, key) in tabs"
                    :key="key"
                    :style="(item == 'Vận hành' && ((filterForm.typeId == 3 && filterForm.schoolLevelId != 1) || showOperateByTestType)) ? {'display':'none'} : {'display':'block'}"
                  >
                    {{item}}
                  </v-tab>

                  <v-tab-item
                      v-for="(item, key) in tabs"
                      :key="key">
                    <v-col cols="12" md="12" class="pt-0 mt-4 contact-history-table--wrapper" >
                      <contact-history-table
                          :style="(tab == 1 && ((filterForm.typeId == 3 && filterForm.schoolLevelId != 1) || showOperateByTestType)) ? {'visibility':'hidden'} : {'visibility':'visible'}"
                          :sheduleInfo="sheduleInfo"
                          :tutorNoteHistory="tutorNoteHistory"
                          :contactHistorys="contactHistorys"
                          :orderList="orderList"
                          :showSTT="false"
                          :contactQuickviewDetail="contactQuickviewDetail"
                          @deleteContactHistory="deleteContactHistory"
                          :currentUserId="currentUserId"
                          @updateContactHistory="updateContactHistory"
                          @setTrialSuccess="getInterviewsDetail"
                          :filterForm="filterForm"
                          :tab="parseInt(tab)"
                          :listTransferOrder="listTransferOrder"
                          :totalListOrder="totalListOrder"
                          :curriculums="curriculums"
                          :typeId="filterForm.typeId"
                          :schoolLevelId="filterForm.schoolLevelId"
                      />
                    </v-col>
                  </v-tab-item>
                </v-tabs>
                <v-col v-if="totalItem > 300" cols="12" md="12" class="pt-0">
                  <v-btn color="success" @click="clickViewHistoryContact">Xem thêm</v-btn>
                </v-col>
              </v-row>
            </validation-observer>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <modal-count-interaction
        v-if="isActiveCountInteractions"
        @closePopUp="closePopupInteractions"
        :isActiveCountInteractions="isActiveCountInteractions"
        :dataInteraction="dataInteraction"
        :totalItemActionLogs.sync="totalItemActionLogs"
        :currentPage.sync="currentPage"
    />
    <modal-active-codes
        v-if="isActiveCodes"
        :isActiveCodes="isActiveCodes"
        :activeCodesCustomer="activeCodesCustomer"
        :dataContact="dataContact"
    />
    <modal-thi-dgnl
        v-if="isPopupDGNL"
        :isPopupDGNL="isPopupDGNL"
        :dataDGNL="dataDGNL"
        @closeModal="closePopupDGNL"
    />
    <school-search-popup
        @closePopup="dialogSearchSchool = false"
        v-if="dialogSearchSchool"
        :is-popup="dialogSearchSchool"
        :info-contact="infoContact"
    />

        <modal-zalo-zns
                v-if="isShowZaloZns"
                :isShowZaloZns="isShowZaloZns"
                :dataContact="dataContact"
        />
    </v-dialog>
    <ModalInfoTryLession :listChild="listChild" :show="showPopupTryLession" @closeDialog="closeDialogTryLession"/>
    <v-dialog
      v-if="showIeltsOnboarding"
      v-model="showIeltsOnboarding"
      content-class="show-try-lession"
      width="800"
    > 
      <ModalOnBoadingIelts :listChild="contactQuickviewDetail.childCustomer"/>
    </v-dialog>
    

    <ModalServey
        v-if="showServeyModal"
        @closePopUp="closeModalServey"
        :showServeyModal="showServeyModal"
        :dataInteraction="dataServey"
        :totalItemActionLogs.sync="totalItemServey"
        :currentPage.sync="currentPageServey"
        :customers="listCustomerServey"
        :customerServey.sync="customerServey"
        :typeServey="typeServey"
        :typeServeySelected.sync="typeServeySelected"
    />
  </div>
</template>
<script>
import TokenService from '../../../helpers/token';
import ContactHistoryTable from './ContactHistoryTable';
import handleSchedule from '@/mixins/handleSchedule';
import {
  contactCreator,
  namesOrderContactStatusTc,
  ORDER_DEPOSIT_TYPE,
  ORDER_FINISH_TYPE,
  moduleTypes,
  moduleSchoolLevel
} from '../../../helpers/constants';
import { showFbMessengerIcon } from '@/helpers/utils'
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import ModalCountInteraction from "./ModalCountIeraction";
import ModalActiveCodes from "./ModalActiveCodes";
import ModalThiDgnl from "./ModalThiDgnl";
import ModalZaloZns from "./ModalZaloZns";
import ModalServey from "@/pages/contact/components/ModalServey.vue";

const ContactRepository = RepositoryFactory.get('contact');
const OrderRepository = RepositoryFactory.get('order');
const CoreActionsLogRepository = RepositoryFactory.get("core_actions_log");
const ContactStatusRepository = RepositoryFactory.get('contact_status');
const TutorTestRepository = RepositoryFactory.get("tutorTest");

import moment from 'moment';
import {mapState, mapMutations} from "vuex";
import SchoolSearchPopup from "@/components/school/school-search-popup.vue";
import ModalInfoTryLession from './ModalInfoTryLession.vue'
import ModalOnBoadingIelts from './ModalOnBoadingIelts.vue'
import {maskedPhoneNumber} from "@/helpers/regex";
export default {
    mixins: [handleSchedule],
    components: {
        SchoolSearchPopup,
        ContactHistoryTable,
        ModalCountInteraction,
        ModalActiveCodes,
        ModalThiDgnl,
        ModalZaloZns,
        ModalInfoTryLession,
        ModalServey,
        ModalOnBoadingIelts,
    },
    name: 'ContactStatusFilterForm',
    props: {
        dataContact: {
            default: () => {},
        },
        contactQuickviewDetail:{

    },
    filterForm: {
      default: () => {},
    },
    // contactStatusList: {
    //   type: Array,
    //   default: () => []
    // },
    users: {
      type: Array,
      default: () => [],
    },
    classListTutor: {
      type: Array,
      default: () => [],
    },
    classListDuo: {
      type: Array,
      default: () => [],
    },
    dataZalo: {
      type: Object,
      default: () => {},
    }

  },
  data() {
    return {
      listChild: [],
      vhUserId: null,
      showPopupTryLession: false,
      showIeltsOnboarding: false,
      moduleTypes,
      moduleSchoolLevel,
      dialogSearchSchool: false,
      isStatusChange: false,
      statusId: 0,
      note: '',
      totalItem: 0,
      contactHistorys: [],
      orderList: [],
      reloadCreateNote: true,
      userId: 0,
      showNote: true,
      currentUserId: '',
      tabs: ['Trao đổi','Vận hành','Log', 'Vận đơn log', 'Đơn hàng', "Lịch sử hỗ trợ"],
      tab: 0,
      isSupport: false,
      isActiveCountInteractions: false,
      dataInteraction: {
        listActions: [],
        cycle_point: 0,
        cumulative_point: 0,
      },
      contactStatusList: [],
      tutorNoteHistory: [],
      sheduleInfo: null,
      activeCodesCustomer: [],
      isActiveCodes: false,
      actionLogTypeList: [],
      mapNamePointActionLog: {},
      totalItemActionLogs: null,
      currentPage: 1,
      dataTime: {},
      listTransferOrder: [],
      listTransferOrderV2: [],
      totalListOrder: [],
      listCallOptions: [],
      isPopupDGNL: false,
      dataDGNL: [],
      curriculums: [],
      tagByContact: [],
      isShowZaloZns: false,
      infoContact: {},
      showServeyModal: false,
      dataServey: [],
      totalItemServey: null,
      currentPageServey: 1,
      customerServey: null,
      typeServey: [],
      typeServeySelected: null,
      isHaveServey: false,
      listCustomerServey: [],
      listReceiptProduct: [],
    };
  },
  async created() {
    this.getListCallOption();
    this.getContactHistory();
    this.checkSupportContact();
    this.isStatusChange = false;
    this.statusId = this.dataContact.statusId;
    this.userId = _.get(this.dataContact, 'user.id', '');
    // this.listChild = this.dataContact.customers;
    this.checkIdsChild(this.dataContact.customers)
    this.currentUserId = await TokenService.getId()
    this.checkShowNote();
    this.getTagsContact();
    Bus.$on('reset-fetch-quick-view-history', () => {
      this.getContactHistory()
      this.checkSupportContact()
    })
    await this.getActionLogTypeList();
    this.getCurriculums();
    if(this.dataContact.typeId && this.dataContact.schoolLevelId) {
      this.selectContactStatusList();
    }
    Bus.$on('zalo-web-hook',data=>{
      if(this.dataContact.id == data.contactId){
        this.dataContact['zuid'] = data.zuid
      }
    });
    Bus.$off('reload-interview')
    Bus.$on('reload-interview', () => {
      this.getInterviewsDetail()
      this.getNote()
    });
    Bus.$on('reload-contactHistory',()=>{
      this.getContactHistory()
    })

    Bus.$on('close-active-code-modal', () => {
      this.isActiveCodes = false
    });

    Bus.$on('get-detail-contact-quickview', (dateTime) => {
      this.currentPage = 1;
      this.dataTime = dateTime;
    });
    Bus.$on('count-list-filter', (dateTime) => {
      this.getDetailContact(dateTime?.month, dateTime?.year);
    })
    Bus.$on('count-list-filter-sersey', () => {
      this.getDataServey();
    })

    Bus.$on('close-zalo-zns-modal', () => {
      this.isShowZaloZns = false
    });
  },
  beforeDestroy () {
    Bus.$off('get-detail-contact-quickview')
    Bus.$off('reload-contactHistory')
    Bus.$off('count-list-filter');
    Bus.$off('close-zalo-zns-modal');
    Bus.$off('count-list-filter-sersey');
  },
  computed: {
    typeSystem() {
      return this.$store.state.module.typeId == this.moduleTypes.IELTS_Y && ( this.$store.state.module.schoolLevelId == this.moduleSchoolLevel.STATION || this.$store.state.module.schoolLevelId == this.moduleSchoolLevel.SCHOOL )
    },
    ...mapState(['isCallWithBrandName','selectedCallOptions']),
    getSelectUser() {
      return this.users;
    },
    requiredNote() {
      return !_.trim(this.note) !== '';
    },
    codeAndMobile() {
      return (
        _.get(this.dataContact, 'code', '') +
        ' - ' +
        _.get(this.dataContact, 'mobile', '')
      );
    },
    isNormalCall(){
      const user = TokenService.getUser();
      return this.checkAuthorization('auto-call_read') || user.username === 'tructoi' || user.username === 'tructoi_caresoft' || user.username === 'Tructongdai_ODS' || user.callcenter_id == 1 || !this.isCallWithBrandName
    },
    // selectContactStatusList() {
    //   const selectType =
    //     this.filterForm.store === 'T' ? ['T1', 'T2', 'T3']
    //       : this.filterForm.store === 'C' ? ['C1', 'C2', 'C3']
    //       : this.filterForm.store === 'G' ? ['G1', 'G2', 'G3'] : ['M1', 'M2', 'M3', 'M5'];
    //   // if (this.isStaff() && !this.checkAuthorization('contact_view_all')) {
    //   //   selectType.shift();
    //   // }
    //   const contactStatusList = [];
    //   const checkType = {};
    //   this.contactStatusList.forEach(contactStatus => {
    //     const typeContactStatus = contactStatus.type;
    //     if (selectType.includes(typeContactStatus.slice(-2)) || _.get(contactStatus, 'id', '') == this.statusId) {
    //       if (!checkType[typeContactStatus]) {
    //         checkType[typeContactStatus] = true;
    //         if (contactStatusList.length > 0) {
    //           contactStatusList.push({ divider: true });
    //         }
    //         contactStatusList.push({
    //           header: typeContactStatus.slice(0, typeContactStatus.length - 4),
    //           style: 'color: red;'
    //         });
    //       }
    //       contactStatus.otherName = `${contactStatus.type.slice(-2)} ${contactStatus.name}`
    //       contactStatusList.push(contactStatus);
    //     }
    //     for(let i=0; i < contactStatusList.length; i++) {
    //       // if(contactStatusList[i].type == "T0" || contactStatusList[i].type == "C0" || contactStatusList[i].header == "T0" || contactStatusList[i].header == "C0")
    //       // {
    //       //   contactStatusList.splice(i,1);
    //       // }
    //     }
    //   });
    //   return contactStatusList;
    // },
    showOperateByTestType() {
      if (!this.curriculums) return true;
      if (!this.curriculums?.length) return true;
      return this.curriculums?.every(item => !item.test_type.length);

    },
    innerWidth() {
      return window.innerWidth;
    },
  },
  watch: {
    tab: {
      handler() {
        this.totalItem = 0;
        this.getContactHistory()
      }
    }
  },
  methods: {
    async checkIdsChild(items) {
      let user_ids = items.filter(item => item.vhUserId).map(item => item.vhUserId)
      let res = await ContactRepository.checkIdInforTryLesson({
        user_ids
      })
      let userIdsValid = res.data.filter(item => item.has_data_trial_report).map(item => item.user_id);
      this.listChild  = items.filter(item => userIdsValid.includes(item.vhUserId))
    },
    closeDialogTryLession(){
      this.showPopupTryLession = false
    },
    closeDialogIeltsOnboarding(){
      this.showIeltsOnboarding = false
    },
    ...mapMutations(['SET_SELECTED_CALL_OPTION', 'SET_DEFAULT_TYPE_AUTO']),
    requiredSupport(customerCode) {
      const routeData = this.$router.resolve({
        path: '/customer-support-v2',
        query: {
          tab:0,
          customerCode,
        }
      });
      window.open(routeData.href, '_blank');
    },
    // search school
   async handlePopupSchool(contactId) {
      if(contactId) {
        try{
          const response = await ContactRepository.detail(contactId)
          if (response.success) {
            if(response.data && response.data.customers) {
              const dataContact = response.data.customers
              if (dataContact.length > 0) {
                this.infoContact = dataContact[0]
                this.dialogSearchSchool = true
              }
            }
          }else {
            this.infoContact = []
          }
        }catch (e) {
          console.log(e)
        }
      }
    },
    // end search school
    setSelectedCallOption(dataContact, phone, option){
      this.SET_SELECTED_CALL_OPTION(option)
      this.clickExecuteCall(dataContact, phone)
    },
    clickAppointmentList(mobile) {
      const routeData = this.$router.resolve({
        name: 'Appointment',
        query: {
          keyword: mobile
        }
      });
      window.open(routeData.href, '_blank');
    },
    clickContactDetail(contactId) {
      const routeData = this.$router.resolve({
        name: 'ContactDetail',
        params: {
          id: contactId || 0
        }
      });
      window.open(routeData.href, '_blank');
    },
    createOrder (contactId) {
      const id = contactId
      // if((this.$store.state.module.typeId && this.$store.state.module.typeId == 2)) {
      //   let routeData = this.$router.resolve({name: 'OrderTutorCreate', params: { id: id }});
      //   window.open(routeData.href, '_blank');
      // }else {
      //   let routeData = this.$router.resolve({name: 'OrderCreate', params: { id: id }});
      //   window.open(routeData.href, '_blank');
      // }
      let routeData = this.$router.resolve({name: 'OrderCreate', params: { id: id }});
      window.open(routeData.href, '_blank');

      // this.$router.push({
      //   name: 'OrderCreate',
      //   params: { id: id }
      // });


    },
    createOrderNew(contactId) {
      const id = contactId
      let routeData = this.$router.resolve({name: 'UpdateContactInfo', params: { id: id }});
      window.open(routeData.href, '_blank');
    },
    clickViewHistoryContact() {
      const contactId = this.dataContact.id;
      this.$router.push({
        name: 'ContactHistory',
        params: {
          id: contactId || 0
        }
      });
    },
    async getContactHistory() {
      const contactId = this.dataContact.id;
      let params = {
        limit: 300,
        page: 0
      }
      if (this.tab == 0) {
        params.action = 'NOTE'
      } else {
        params.ne_action = ['NOTE', 'OPERATION']
      }
      if(this.tab < 3 && this.tab != 1) {
        this.loading = true;
        const loader = this.$loading.show();
        const response = await ContactRepository.getContactHistorys(
            params,
            contactId
        );
        loader.hide();
        this.loading = false;
        if (response.success) {
          this.contactHistorys = _.get(response, 'data', []).map(contact => {
            const contactTemp = contact;
            contactTemp.creatorFullName = _.get(
                contactTemp,
                'creator.fullName',
                null
            );
            if (!contactTemp.creatorFullName) {
              contactTemp.creatorFullName =
                  contactCreator[contact.createdBy] || '';
            }
            contactTemp.editable = false
            return contactTemp;
          });
          this.totalItem = response.totalItem;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          });
          this.contactHistorys = [];
          this.totalItem = 0;
        }
      } else if( this.tab == 3 ) {
        this.loading = true;
        const loader = this.$loading.show();
        const response = await ContactRepository.getContactHistorysTransportNote(
            params,
            contactId
        );
        loader.hide();
        this.loading = false;
        if (response.success) {
          this.contactHistorys = this.contactHistorys = _.get(response, 'data', []).map(contact => {
            const contactTemp = contact;
            contactTemp.creatorFullName = _.get(
                contactTemp,
                'user.full_name',
                ''
            );
            return contactTemp
          });
          this.totalItem = response.totalItem;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          });
          this.contactHistorys = [];
          this.totalItem = 0;
        }
      } else if(this.tab === 4) {
        params.contactId = contactId;
        params.code = '';
        this.loading = true;
        const loader = this.$loading.show();
        const [response, responseTutor, transferFeeV2, resReceipt] = await Promise.all([
          OrderRepository.listV2({
            ...params,
            fromQuickView: 1
          }),
          OrderRepository.getTransferOrderStudents(contactId),
          OrderRepository.getTransferOrderStudentsV2(contactId),
          OrderRepository.getHistoryReceiptApi(contactId)
        ])
        // const response = await OrderRepository.listV2({
        //   ...params,
        //   fromQuickView: 1
        // });
        // const responseTutor = await OrderRepository.getTransferOrderStudents(contactId)
        loader.hide();
        this.loading = false;
        if(responseTutor.success) {
           this.listTransferOrder = _.get(responseTutor, 'data', []);
        }
        if(transferFeeV2.success) {
          this.listTransferOrderV2 = _.get(transferFeeV2, 'data', []).map((el) => ({
            ...el,
            isTransferOrder: true,
            version: 2,
          }));
        }
        if(resReceipt.success) {
          this.listReceiptProduct = _.get(resReceipt, 'data', []).map((el) => ({
            ...el,
            isReceiptOrder: true,
            version: 2,
          }));
        }
        if (response.success) {
          this.orderList = _.get(response, 'data.data', []);
          this.totalItem = response.totalItem;
        } else {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(response, 'message', '')
          });
          this.orderList = [];
          this.totalItem = 0;
        }
        const totalListOrder = await Promise.all(this.orderList.concat(this.listTransferOrder).concat(this.listTransferOrderV2).concat(this.listReceiptProduct).map(async (s) => {
          let depositLabel = null;
          let hasFinishOrder = null;
          let isAllTheSameUserCreate = null;
          if (s.isGroupOrder) {
            let depositOrder = s.listOrders.find(item => item.orderType == ORDER_DEPOSIT_TYPE);
            if (depositOrder) {
              s.code = depositOrder.code;
              s.depositOrderId = depositOrder.id;
            }

            for (let i =  0; i < s.listOrders.length; i++) {
              // call api trail
              const trailData = await OrderRepository.getTrailOfOrder(s.listOrders[i].id)

              let trailProduct = [];
              if (trailData.success) {
                trailProduct = _.get(trailData, 'data.trailProductData', [])
              }
              s.listOrders[i].isTrail = trailProduct.length ? true : false;
              // console.log('s.listOrders[i].id trailProduct: ', s.listOrders[i].id, trailProduct.length)

              s.listOrders[i].products = s.listOrders[i].products.map(prod => {
                let trailProductFind = trailProduct.find(trailP => trailP.productId == prod.productId && trailP.customerId == prod.customerId)
                let numberLessons = trailProductFind ? s.listOrders[i].orderType == ORDER_DEPOSIT_TYPE ? trailProductFind.trailLessons : +(trailProductFind.numberOfSection - trailProductFind.trailLessons) : null;
                return {
                  ...prod,
                  numberLessons
                }
              })

              s.listOrders[i].combos = s.listOrders[i].combos.map(prod => {
                let numberLessons = 0;
                return {
                  ...prod,
                  numberLessons
                }
              })
            }
            depositLabel = this.getDepositLabel(s.listOrders);
            hasFinishOrder = s.listOrders.findIndex(e => e.orderType == ORDER_FINISH_TYPE) > -1 ? true : false;
            isAllTheSameUserCreate = this.isAllTheSameUser(s.listOrders);
          }
          if (s && (s.isTransferOrder || s.isReceiptOrder)) {
            return {
              ...s,
              statusOrder: true,
              hasFinishOrder,
              depositLabel,
              createdAt:  moment(s.createdAt).format('YYYY-MM-DD HH:mm:ss'),
            };
          }
          if(s.created_date) {
            return {
              ...s,
              createdAt:  moment(s.created_date).format('YYYY-MM-DD HH:mm:ss'),
              statusOrder: true,
              version: 1,
              hasFinishOrder,
              depositLabel
            }
          } else {
            return {
              ...s,
              statusOrder: false,
              hasFinishOrder,
              depositLabel,
              isAllTheSameUserCreate
            }
          }
        }))

        this.totalListOrder =  _.orderBy(totalListOrder, ['createdAt'], ['ASC']).reverse()
        // console.log('totalListOrder: ', totalListOrder)
      }
      else if(this.tab ==1 ){
        this.getInterviewsDetail();
        this.getNote()
      }

    },
    async getListCallOption() {
      if(this.listCallOptions.length < 1 ){
        let responseListCallOptions = await ContactRepository.getCallOptions(this.dataContact.id)
        if(responseListCallOptions && responseListCallOptions.success) {
          this.listCallOptions = responseListCallOptions.data
        }
      }
    },
    async clickCreateHistoryContact() {
      if (_.trim(this.note) == '') {
        this.reloadCreateNote = true;
        return;
      }
      const dataUpdate = {
        contactId: this.dataContact.id,
        description: _.trim(this.note)
      };
      let loading = this.$loading.show();
      const response = await ContactRepository.createContactHistory(dataUpdate, this.dataContact.id);
      loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: this.errorMessage,
          }).then(() => {});
        return;
      }
      this.note =  ' ';
      this.reloadCreateNote = false;
      this.getContactHistory();
    },
    async changeSelectStatus() {
      // return this.$swal({
      //   title: 'Bạn muốn thay đổi mối quan hệ ?',
      //   type: 'warning',
      //   showCancelButton: true,
      //   confirmButtonText: 'Đồng ý',
      //   closeOnConfirm: false,
      //   cancelButtonText: 'Huỷ Bỏ'
      // }).then(async result => {
      //   if (result.value) {
          this.isStatusChange = true;
          this.dataContact.statusId = this.statusId;
          return this.callAPIChangeStatus();
        // }
        this.statusId = this.dataContact.statusId;
      // });
    },
    async callAPIChangeStatus() {
      const dataUpdate = [
        {
          contactId: this.dataContact.id,
          statusId: this.statusId
        }
      ];
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactStatus(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: this.errorMessage,
          }).then(() => {});
      }
    },
    async changeSelectUser() {
      if(!this.userId) {
        return this.$swal({
          title: 'Chọn người phụ trách là bắt buộc?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
        })
      }
      return this.$swal({
        title: 'Bạn muốn thay đổi người phụ trách ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        closeOnConfirm: false,
        cancelButtonText: 'Huỷ Bỏ'
      }).then(async result => {
        if (result.value) {
          this.isStatusChange = true;
          if (!this.dataContact.user) {
            this.dataContact.user = {};
          }
          this.dataContact.user.id = this.userId;
          return this.callAPIChangeUser();
        }
        this.userId = _.get(this.dataContact, 'user.id', '');
      });
    },
    async callAPIChangeUser() {
      const dataUpdate = [
        {
          contactId: this.dataContact.id,
          userId: this.userId
        }
      ];
      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactUser(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: this.errorMessage,
          }).then(() => {});
      }
    },
    clickNewAppointment(dataContact) {
      const data = {
        contactId: dataContact.id,
        mobile: dataContact.mobile,
        fullName: dataContact.fullName,
        contactSources: dataContact.contactSources,
        from: 'quickView',
        childCustomer: dataContact.childCustomer
      };
      Bus.$emit('appointment-show-form-from-contact', data);
    },
    clickHistoryCall(mobile) {
      const routeData = this.$router.resolve({
        name: 'CallCenterList',
        query: {
          keyword: mobile
        }
      });
      window.open(routeData.href, '_blank');
    },
    async clickExecuteCall(dataContact, phone, isAutoScript = false, value) {
      console.log("value: ", value);
      if((value == 'ZL_BGVVH' && !this.dataZalo.ZL_BGVVH) || (value == 'ZL_CVHT' && !this.dataZalo.ZL_CVHT)) {
        this.$swal({
          text: 'Học sinh / Phụ huynh đã không tương tác qua zalo với vuihoc hơn 30 ngày.'
        })
        return
      }
      // if(value && value == 'ZL_CVHT' && !this.dataZalo.ZL_CVHT) {
      //   this.$swal({
      //     text: 'Học sinh / Phụ huynh đã không tương tác qua zalo với vuihoc hơn 30 ngày.'
      //   })
      //   return
      // }
      console.log("value: ", value);
      if (this.isNormalCall && !value) {
        let user = TokenService.getUser()
        if (user.ext) {
          const data = {
            mobile: phone,
            showCreateAppointment: false,
            contactId: dataContact.id,
            mainId: dataContact.mainId,
            mainMobile: dataContact.mobile,
            contactCode: dataContact.code,
          }
          Bus.$emit('voice-call-show-popup', data)
        } else {
          this.$swal({
            title: 'Thông báo!',
            text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.'
          })
        }
      } else {
        let body = {
          contactId: dataContact.id,
          type: this.selectedCallOptions.type,
          brandnameCode: this.selectedCallOptions.brandnameCode ? this.selectedCallOptions.brandnameCode : null,
        }
        if(value) {
          console.log("value222: ", value);
          body.type = 'manual';
          body.brandnameCode = value;
        }

        if (isAutoScript) {
          console.log("isAutoScript: ", isAutoScript);
          body.type = 'auto';
          body.brandnameCode = null;
          this.SET_DEFAULT_TYPE_AUTO(1)
        } else {
          this.SET_DEFAULT_TYPE_AUTO(0)
        }
        let ext = ''
        let password = ''
        let callcenter_id = ''
        let group_id = ''
        let res = await ContactRepository.getCallInfo(body)
        if (res && res.success) {
          ext = res.data[0].ext;
          password = res.data[0].extPassword;
          callcenter_id = res.data[0].callcenterId;
          group_id = res.data[0].groupId;
        } else {
          if (_.get(res, 'errors.errorCode', null) == 4) {
            this.$swal({
              title: 'Thông báo!',
              text: _.get(res, 'errors.message', null)
            })
          } else {
            this.$swal({
              title: 'Thông báo!',
              text: 'Chưa có máy lẻ. Vui lòng liên hệ Sale Admin.'
            })
          }
          return
        }

        let data = {
          mobile:(value &&  value == 'ZL_BGVVH') ? (99 + this.dataZalo.zuid_ZL_BGVVH) : (value && value == 'ZL_CVHT') ? (99 + this.dataZalo.zuid_ZL_CVHT) : phone ,
          showCreateAppointment: false,
          contactId: dataContact.id,
          callcenter_id: callcenter_id,
          mainId: dataContact.mainId,
          mainMobile: dataContact.phoneRelated[0],
          store: this.filterForm.store,
          groupId: group_id
        }
        console.log(data, 'data')
        if (callcenter_id == 1) {
          await Bus.$emit('init-epa-call-center', ext, password, data);
        } else if (callcenter_id == 2) {
          await Bus.$emit('init-care-soft-call-center', ext, data);
        } else if (callcenter_id == 4) {
          console.log('vào đây :>> ', value);
          await Bus.$emit('init-ods-call-center', ext, password, data, value);
        }
      }
    },
    closeModal() {
      this.filterForm.openQuickView = false;
      if (this.isStatusChange) {
        // this.searchContact();
      }
    },
    searchContact() {
      Bus.$emit('contact-list-filter', this.filterForm);
      Bus.$emit('contact-status-list');
    },
    checkShowNote () {
      this.checkAuthorization('contact_update') ? this.showNote = true : this.showNote = false
    },
    async deleteContactHistory (contactHistory) {
      this.$swal({
        title: 'Xóa lịch sử',
        text: 'Bạn có thực sự chắc chắn ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ',
      }).then(async (result) => {
        if (result.value) {
          const loader = this.$loading.show()
          let res = await ContactRepository.deleteContactHistory(contactHistory.id)
          loader.hide()
          if (res.success) {
            this.$swal({
                      title: 'Xóa thành công !',
                      confirmButtonText: 'Đồng ý',
                    },
            ).then(() => {
              this.getContactHistory()
            })
          } else {
            this.$swal({
              type: 'error',
              title: 'Lỗi !',
              text: _.get(res, 'message', ''),
            })
          }
        }
      })
    },
    async updateContactHistory(contactHistory) {
      // this.loading = this.$loading.show()
      let res = await ContactRepository.updateContactHistory(contactHistory.id, {'description': contactHistory.description})
      // this.loading.hide()
      if (res.success) {
        this.getContactHistory()
      } else {
        this.errorMessage = _.get(res, 'message', '');
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: this.errorMessage,
          }).then(() => {})
        this.getContactHistory()
      }
    },
    async returnToBackStatus() {
      let loading = this.$loading.show()
      let response = await ContactRepository.returnToBackStatus(this.dataContact.id)
      loading.hide()
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: this.errorMessage,
          }).then(() => {});
        return;
      }
      this.dataContact.beforeSupport = null;
      this.getContactHistory();
    },
    showAppoimentAction(contact, phone) {
      const appointmentDetail = {
        id: contact.appointment.id,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        customer: {
          contactId: contact.id
        },
        mobile: phone
      }
      Bus.$emit('appointment-show-form-from-action', appointmentDetail)
    },
    statusCallCenter() {
      return (
        this.checkAuthorization('call_center_read') ||
        this.checkAuthorization('call_center_view_all')
      );
    },
    editAppointment (contact) {
      const appointmentDetail = {
        id: contact.appointment.id,
        mainId: contact.mainId,
        mainMobile: contact.phoneRelated[0],
        customer: {
          contactId: contact.id
        }
      }
      Bus.$emit('appointment-show-form-from-appointment', appointmentDetail)
    },
    checkContactSources(contactSources) {
      return showFbMessengerIcon(contactSources)
    },
    async checkSupportContact() {
      let statusId = _.get(this.dataContact, 'statusId', 0)
      let beforeSupport = _.get(this.dataContact, 'beforeSupport', 0)
      let contactId = _.get(this.dataContact, 'id', 0)
      if (((statusId >= 4 && statusId <= 13) || statusId == 49) && parseInt(beforeSupport) && contactId) {
        const params = {
          contactId: contactId,
          code: ''
        }
        const res = await OrderRepository.list(params)
        if (res.success) {
          this.isSupport = _.get(res, 'data.totalItem', 0) > 0
        } else {
          this.$swal({
            title: 'Lỗi !',
            text: _.get(res, 'message', '')
          })
        }
      }
      // this.isSupport = false
    },
    async getDetailContact(month = null, year = null) {
      const result = {
        listActions: [],
      };
      let params = {
        contactId: this.dataContact.id,
        limit: 10,
        page: this.currentPage - 1,
      };
      if (month && year){
        params.month = month
        params.year = year
      }else{
        params.month = this.dataTime.month
        params.year = this.dataTime.year
      }
      // if (month != null && year != null) {
      //   params.month = month
      //   params.year = year
      // }
      const loader = this.$loading.show();
      const res = await CoreActionsLogRepository.detail(params);
      loader.hide();
      if (res.error) {
        return (this.dataInteraction = []);
      }
      result.cycle_point = _.get(res, "data.points.cyclePoint", 0);
      result.cumulative_point = _.get(res, "data.points.cumulativePoint", 0);
      _.get(res, "data.actionLogs.data").forEach((e) => {
        result.listActions.push({
          create_date: _.get(e, "create_date", "Lỗi hệ thống"),
          interaction: _.get(e, "action", "Lỗi hệ thống"),
          fullName: _.get(e, "fullName", "Lỗi hệ thống"),
          point: e.point ?? 0,
          data: _.get(e, "data", "Lỗi hệ thống")
        });
      });
      this.totalItemActionLogs = res.data.actionLogs.totalItem;
      return (this.dataInteraction = result);
    },
    async getDataServey() {
      const params = {
        obj: 'survey_ldp_pas',
        "filters[$eq__contact_id]": this.dataContact.id,
        // "filters[$eq__contact_id]": 24214,
        'attrs': [
          'id', 'time', 'result_1', 'result_2', 'result_3', 'result_4',
          'link', 'customer_id', 'contact_id', 'phone', 'type'
        ],
        limit: 10,
        page: this.currentPageServey - 1,
        'filters[$eq__customer_id]' : this.customerServey,
        'filters[$eq__type]' : this.typeServeySelected,
      }

      const res = await CoreActionsLogRepository.listServey(params);
      this.totalItemServey = res.totalItem;
      this.dataServey = res.data;

    },
    async getListTypeServey() {
      const res = await CoreActionsLogRepository.listTypeServey();
      this.typeServey = res.data.map((item) => {
        return {
          id: item,
          text: item
        }
      });
      this.typeServeySelected = this.typeServey[0].id;
    },
    viewInteractions() {
      let date = new Date()
      this.isActiveCountInteractions = true;
      this.getDetailContact(date.getMonth() + 1, date.getFullYear());
    },
    closePopupInteractions(variable) {
      this.dataTime = {};
      // this.getDetailContact();
      this.isActiveCountInteractions = variable;
    },
    closeModalServey(variable) {
      this.currentPageServey = 1;
      this.showServeyModal = variable;
    },
    async selectContactStatusList() {
      const selectType =
          _.get(this.dataContact, 'contactStatus.type', 'T').includes('T')
              ? ['T1', 'T2', 'T3']
              : ['C1', 'C2', 'C3'];
      if (this.isStaff() && !this.checkAuthorization('contact_view_all')) {
        selectType.shift();
      }

      const contactStatusList = [];
      // const loading = this.$loading.show();
      const response = await ContactStatusRepository.list({
        store: this.dataContact.store,
        typeId: this.dataContact.typeId,
        schoolLevelId: this.dataContact.schoolLevelId
      });
      // loading.hide();
      if (response.success) {
        const checkType = {};
        _.get(response, 'data', []).forEach(contactStatus => {
          const typeContactStatus = contactStatus.type;
          const listStatusChild = _.get(contactStatus, 'data', [])
          if (
              selectType.includes(typeContactStatus.slice(-2)) ||
              (listStatusChild.findIndex(elc => elc.id == this.dataContact.statusId) > -1)
          ) {
            if (!checkType[typeContactStatus]) {
              checkType[typeContactStatus] = true;
              if (contactStatusList.length > 0) {
                contactStatusList.push({divider: true});
              }
              contactStatusList.push({
                header: typeContactStatus.slice(0, typeContactStatus.length - 4),
                style: 'color: red;'
              });

              listStatusChild.forEach(data => {
                if(selectType.includes(typeContactStatus.slice(-2)) ||
                    (data.id == this.dataContact.statusId)) {
                  data.otherName = `${typeContactStatus.slice(-2)} ${data.name}`
                  contactStatusList.push({
                    id: _.get(data, 'id', 0),
                    otherName: _.get(data, 'otherName', ''),
                    type: _.get(data, 'type', ''),
                  });
                }
              });
            }
          }
        });
      }
      this.contactStatusList = contactStatusList;
    },
    async getInterviewsDetail() {
      const res = await TutorTestRepository.getInterviewsDetail(
          this.contactQuickviewDetail.id
      );
      let sheduleInfo = _.get(res, "data");
      this.sheduleInfo = sheduleInfo.map((s) => {
        return {
          ...s,
          note: '',
        };
      });
    },
    async getNote() {
      let params = {
        action: "OPERATION",
      };
      const res = await TutorTestRepository.getNote(
          this.contactQuickviewDetail.id,
          params
      );
      let contactHistorys = res.data;
      this.tutorNoteHistory = contactHistorys.map((s) => {
        return {
          editable: false,
          ...s,
        };
      });
    },
    viewActiveCodes() {
      this.isActiveCodes = true;
    },
    async viewLogDGNL(dataContact) {
      this.isPopupDGNL = true;
      const res = await ContactRepository.getListLogDGNL(dataContact.id, {});
      if (!res.success) {
        this.$swal({
          title: 'Lỗi !',
          text: _.get(res, 'message', ''),
          timer: 3000
        })
        return;
      }
      this.dataDGNL = res.data;
    },
    closePopupDGNL() {
      this.isPopupDGNL = false;
      this.dataDGNL = [];
    },
    async getActionLogTypeList() {
      if (this.$store.state.listActionLogType) {
        this.actionLogTypeList = this.$store.state.listActionLogType;
        // return;
      } else {
        const res = await CoreActionsLogRepository.listActionLogType();
        if (res.success) {
          this.actionLogTypeList = _.get(res, 'data', [])
        }
        if (this.actionLogTypeList && this.actionLogTypeList.length) {
          this.$store.dispatch('SET_LIST_ACTION_LOG_TYPE', this.actionLogTypeList)
        }
      }

      this.actionLogTypeList.forEach(item => {
        if (!this.mapNamePointActionLog[item.name]) {
          this.mapNamePointActionLog[item.name] = item.point
        }
      })
    },
    formatDateTime(date) {
      return moment(date).format('DD-MM-YYYY');
    },
    getClassListOfChild(key, customerId) {
      if(customerId){
        this.vhUserId = customerId
      }
      $(".customer-learning").removeClass("active");
      $(`#customer-learning-${key}`).addClass("active");
      Bus.$emit('get-class-list-of-child', (customerId));
    },
    getDepositLabel(listOrder) {
      if (listOrder.every(item => namesOrderContactStatusTc.includes(_.get(item,'contactStatus.name', '').toUpperCase())) && listOrder.some(item => item.orderType == ORDER_FINISH_TYPE)) {
        return 'Đã hoàn thành phí'
      } else if (listOrder.some(item => namesOrderContactStatusTc.includes(_.get(item,'contactStatus.name', '').toUpperCase()))) {
        return 'Đã thanh toán 1 phần'
      } else {
        return 'Chưa thanh toán';
      }
    },
    isAllTheSameUser(listOrder) {
      if (!listOrder) return true;
      let userId = _.get(listOrder[0], 'userId', null);
      for (let k = 1; k < listOrder.length; k++) {
        if (listOrder[k].userId != userId) {
          return false
        }
      }
      return true
    },
    async getCurriculums() {
      const params = `getCurriculums.type_contact_id.${this.dataContact.typeId}`
      const res = await ContactRepository.getListCurriculum(params);
      this.curriculums = _.get(res, 'data', []) || [];
      this.curriculums = _.chain(this.curriculums)
          .filter(item => item.test_type.length)
          .filter(item => !item.type_school_level_id.length || item.type_school_level_id.includes(this.dataContact.schoolLevelId))
          .value();
    },
    async getTagsContact() {
      const params = {
        obj: "contact_tags",
        "filters[$eq__contactId]" : this.dataContact?.id,
        attrs: ["id", "tagCode", "tagIcon", "tagName", "tagColor", "data"]
      }
      const response = await ContactRepository.getListTags(params);
      this.tagByContact = _.get(response, 'data')
      this.isHaveServey = _.some(this.tagByContact, ['tagCode', 'DalamSurvey']);
    },
    openLink(tag) {
      if(tag.tagCode == 'BaoCaoHocThuDUO'){
        this.showPopupTryLession = true
      }
      if (tag.tagCode == 'OnboardingConversation') { 
        this.showIeltsOnboarding = true
        return;
      }
      if (!tag.data) return;
      const link = JSON.parse(tag.data);
      window.open(link.result_link, '_blank');
    },
    showModalZaloZns () {
      this.isShowZaloZns = true
    },
    isReserve(item) {
      if (
          item.status_name === 'Bảo lưu'
      ) {
        return true;
      }
      return false;
    },
    async handlePopupServey() {
      this.showServeyModal = true;
      const response = await ContactRepository.detail(this.dataContact.id);
      if (response.data && response.data.customers) {
        const customers = response.data.customers;
        let mainCustomer = customers[0].id;
        const findMain = customers.find(item => item.isMainCustomer);
        if (findMain) mainCustomer = findMain.id
        this.customerServey = mainCustomer;
        this.listCustomerServey = customers;
      }
      this.handlePopupSchool();
      this.getListTypeServey();
      this.getDataServey();
    }
  }
};
</script>
<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
.contact-history-table--wrapper {
  max-height: 100%;
  overflow: auto;
}
/deep/ .v-tabs-bar {
  height: 30px;
}
/deep/ .v-tab {
  font-size: 12px;
}
.appointment-time-wrapper{
  padding: 5px;
  border: 1px solid #A9A9A9;
  border-radius: 5px;
  font-weight: 700;
}
.class-list {
  background: #F7F7FC;
  overflow: auto;
  max-height: 400px;
}
.class-item {
  border: 1px solid #D2D2D2;
  border-radius: 5px;
  background: #fff;
  padding: 5px 14px;
}
.schedule-day {
  font-weight: 600;
  /* background-color: rgb(233, 237, 245);
  border-color: rgb(233, 237, 245);
  padding: 4px 6px;
  border-radius: 6px !important; */
}
.customer-learning {
  background: #E0E0E0;
  color: #828282;
  font-size: 13px;
  font-weight: 500;
  padding: 0 12px;
  border-radius: 2px;
}
.active {
  background: #9ad8ff;
  color: #2F80ED;
  border: 1px solid #0395EE;
}
.label-class-type {
  color: #fff;
  border-radius: 12px;
  width: 60px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .select-assign-user .v-chip.v-size--default {
  max-width: 80%;
}
.join-date-tooltip {
  border: 1px solid;
  border-color: #ccc !important;
  opacity: 1;
  color: black;
  padding: 6px;
}
</style>
<style lang="scss">
.custom-width-ml {
  padding-left: 80px !important;
  margin: 0px !important;
}
</style>
